import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, Protected } from "@/context/AuthContext";
import LoginPage from "@/pages/LoginPage";
import BooksPage from "@/pages/BooksPage";
import SheetPage from "@/pages/SheetPage";
import SummaryPage from "@/pages/SummaryPage";
import SettingsPage from "@/pages/SettingsPage";
import PrintPage from "@/pages/PrintPage";
import SharePage from "@/pages/SharePage";
import StaffPage from "@/pages/StaffPage";
import ActivityPage from "@/pages/ActivityPage";
import ReasonsPage from "@/pages/ReasonsPage";
import CashoutsPage from "@/pages/CashoutsPage";
import PersonLedgerPage from "@/pages/PersonLedgerPage";
import CashoutPrintPage from "@/pages/CashoutPrintPage";
import PublicCashoutsPage from "@/pages/PublicCashoutsPage";
import PublicPersonPage from "@/pages/PublicPersonPage";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<Protected><BooksPage /></Protected>} />
          <Route path="/book/:id" element={<Protected><SheetPage /></Protected>} />
          <Route path="/summary" element={<Protected><SummaryPage /></Protected>} />
          <Route path="/settings" element={<Protected><SettingsPage /></Protected>} />
          <Route path="/book/:id/print" element={<Protected><PrintPage /></Protected>} />
          <Route path="/activity" element={<Protected><ActivityPage /></Protected>} />
          <Route path="/cashouts" element={<Protected><CashoutsPage /></Protected>} />
          <Route path="/cashouts/person" element={<Protected><PersonLedgerPage /></Protected>} />
          <Route path="/cashouts/print" element={<Protected><CashoutPrintPage /></Protected>} />
          <Route path="/c/:token" element={<PublicCashoutsPage />} />
          <Route path="/p/:token" element={<PublicPersonPage />} />
          <Route path="/reasons" element={<Protected><ReasonsPage /></Protected>} />
          <Route path="/staff" element={<Protected><StaffPage /></Protected>} />
          <Route path="/s/:token" element={<SharePage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </AuthProvider>
  );
}

export default App;
